// react_component('Settings/PushNotificationSettings/PushNotificationTypesPanel') resolves this
// directory through require.context in frontend/packs/application.js and mounts its DEFAULT export,
// so the re-export is structural rather than stylistic (same shape as the Technicians barrels).
// eslint-disable-next-line no-restricted-exports
export { default } from './PushNotificationTypesPanel';
export * from './types';
